
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiDockBottomGoogle as ObiDockBottomGoogleElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-dock-bottom-google.js';
 
 
 

 
 export const ObiDockBottomGoogle = createComponent({
   react: React,
   tagName: 'obi-dock-bottom-google',
   elementClass: ObiDockBottomGoogleElement,
   events: {
     
   }
  });
 
 